
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteW as ObiOwnShipRemoteWElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-w.js';
 
 
 

 
 export const ObiOwnShipRemoteW = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-w',
   elementClass: ObiOwnShipRemoteWElement,
   events: {
     
   }
  });
 
 